// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n5GE","type":"styles_type__NJlvF","choices":"styles_choices__3wDUp"};